module.exports = __webpack_public_path__ + "img/ic_services_spa.162ccc2d.svg";